import { renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["animated", [_ctx.shouldSlideIn ? 'fadeIn' : 'fadeOut']])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2)), [
    [_vShow, _ctx.shouldShowSection]
  ])
}